import { Grid } from '@mui/material'
import MergeService from '../service/merge'
import React from 'react'
import Search from './search/Search'
import SearchResults from './searchresults/SearchResults'
import SearchService from '../service/search'

function MergeTool() {
  return (
    <Grid container>
      <Grid item sm={4} xs={12}>
        <Search searchService={SearchService} />
      </Grid>
      <Grid item sm={8} xs={12}>
        <SearchResults
          mergeService={MergeService.merge}
          searchService={SearchService}
        />
      </Grid>
    </Grid>
  )
}

export default MergeTool
